import { v4 as uuid } from 'uuid';

import {
  setUnsubscribeUsersStatusFailed,
  setUnsubscribeUsersStatusPending,
  setUnsubscribeUsersStatusSuccess,
} from './actions';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ISessionSucceedState } from '../../types/session';
import { ETelemetryEvents } from '../../types/telemetry';
import { IWSClientUnsubscribeUsersStatusSchema } from '../../types/usersStatus';
import { timeoutPromise } from '../../utils/timeoutPromise';
import { EInternetStatus } from '../internetStatus';
import { setSocketFailed } from '../socket';

/**
 * Отписка по сокету от получения статуса по массиву id пользователей
 */
export const unsubscribeUsersStatus =
  (requestedUserIds: number[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry }) => {
    const {
      session: { status, token },
      socket: { eventChannel, clientEvents, status: socketStatus },
      internetStatus,
    } = getState();

    dispatch(setUnsubscribeUsersStatusPending());

    const isSessionExpired = status !== ERequestApiStatus.Succeed;
    const isSocketIsClose = eventChannel.isChannelClosed() || socketStatus === ERequestApiStatus.Failed;
    const isOffline = internetStatus === EInternetStatus.Offline;

    const uid = uuid();

    if (isSocketIsClose) {
      dispatch(setSocketFailed());
    }

    if (isSessionExpired || isSocketIsClose || isOffline) {
      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());

      return;
    }

    const wsStatusEvent: IWSClientUnsubscribeUsersStatusSchema = {
      type: 'status',
      uid,
      userId: (token as ISessionSucceedState['token']).userId,
      sessionToken: (token as ISessionSucceedState['token']).sessionToken,
      requestedUserIds,
      action: 'unsubscribe',
    };

    clientEvents.set(uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.UnsubscribeUsersStatus,
    });

    try {
      await timeoutPromise(eventChannel.unsubscribeUsersStatus(wsStatusEvent), 10000);
      dispatch(setUnsubscribeUsersStatusSuccess());
    } catch (err) {
      logger.warning(err, {
        domain: 'frontend-chats.unsubscribeUsersStatus.ts',
        message: 'Не удалось отписаться от статуса пользователей по ws',
      });
      telemetry.increment(ETelemetryEvents.ChatWsUserStatusFail);

      clientEvents.set(uid, { type: EWsClientEventType.UnsubscribeUsersStatus, status: ERequestApiStatus.Failed });
      dispatch(setUnsubscribeUsersStatusFailed());
    }
  };
